let TrackingDetailsMetricsEvent = /*#__PURE__*/function (TrackingDetailsMetricsEvent) {
  TrackingDetailsMetricsEvent["OnClickTrackingNumber"] = "onClickTrackingNumber";
  TrackingDetailsMetricsEvent["OnClickContactCenter"] = "onClickContactCenter";
  return TrackingDetailsMetricsEvent;
}({});

export { TrackingDetailsMetricsEvent };
//# sourceMappingURL=types.js.map
